<template>
  <div class="sub-theme-content">
    <div
      class="arrow-shape-left left-arrow"
      :title="$t('views.themeView.subTheme.slideToLowerLevel')"
      v-show="firstDisplayedColumnIndex > 0"
      @click="slideColumn('left')"
    ></div>

    <div class="sub-theme-row">
      <div
        class="slice-column-container"
        :style="{width: columnWidth}"
        v-for="index in nbDisplayedColumns"
        :key="index"
      >
        <slice-column
          :edit="edit"
          :themeAbbr="themeAbbr"
          :subThemeRef="subThemeRef"
          :situationDescriptions="contentListBySlice[firstDisplayedColumnIndex + index - 1]"
          :dataType="dataType"          
          :printMode="printMode"
        ></slice-column>
      </div>
    </div>

    <div
      class="arrow-shape-right right-arrow"
      :title="$t('views.themeView.subTheme.slideToUpperLevel')"
      v-show="firstDisplayedColumnIndex + nbDisplayedColumns < 4"
      @click="slideColumn('right')"
    ></div>

  </div>
</template>

<script>
import SliceColumn from "./SliceColumn";

export default {
  name: "LevelSection",
  components: {
    SliceColumn
  },
  props: {
    edit: Boolean,
    themeAbbr: String,
    subThemeRef: String,
    contentList: Array, // liste des situationDescriptions ou des objectificationElements
    dataType: String, // savoir si on est dans OBSERVATIONS ou OBJECTIFICATIONS
    printMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Renvoie le nb de colonnes à afficher simultanément.
     * @returns {number} nb de colonnes à afficher simultanément
     */
    nbDisplayedColumns: function() {
      if (this.printMode) {
        return 4;
      } else {
        return this.$store.state.appState.themesColumns.nbDisplayedColumns;
      }
    },

    /**
     * Renvoie l'index de la première colonne à afficher.
     * @returns {number} index de la première colonne à afficher.
     */
    firstDisplayedColumnIndex: function() {
      return this.$store.state.appState.themesColumns.firstDisplayedColumnIndex;
    },

    /**
     * Calcule la largeur d'affichage d'une colonne.
     * @returns {string} largeur d'affichage
     */
    columnWidth: function() {
      return (
        100 / this.nbDisplayedColumns + "%"
      );
    },

    /**
     * Ventilation des descriptions de situation par colonne de niveau.
     *
     * @returns {Array.<Object>} Tableau d'objets (tranche, descriptions de situation associées) pour chaque tranche, dans l'ordre.
     */
    contentListBySlice: function() {
      // Récupération des tranches de niveau
      var slices = this.$store.state.gpsstModule.gpsst.slices;

      // Initialisation des objets colonnes et du mapping [référence de slice => index de colonne]
      var situationDescriptionBySlice = [],
        sliceRefToColMap = {};
      for (var i = 0; i < slices.length; i++) {
        var slice = slices[i];
        situationDescriptionBySlice.push({ slice: slice, descriptions: [] });
        sliceRefToColMap[slice.ref] = i;
      }

      // Ventilation des descriptions de situation dans les colonnes concernées
      var descriptions = this.contentList;
      for (var j = 0; j < descriptions.length; j++) {
        var description = descriptions[j];

        if (sliceRefToColMap.hasOwnProperty(description.sliceRef)) {
          situationDescriptionBySlice[
            sliceRefToColMap[description.sliceRef]
          ].descriptions.push(description);
        } else {
          if (this.$store.state.appState.env === "DEV") {
            console.warn(
              "LevelsSection.contentListBySlice",
              "Référence de tranche inconnue pour cette  description => la description a été ignorée.",
              description
            );
          }
        }
      }

      return situationDescriptionBySlice;
    }
  },
  methods: {
    /**
     * Fait glisser (= décale) d'un cran vers la gauche ou la droite l'affichage des colonnes dans la page d'évaluation d'un thème.
     *
     * @param {string} direction - Direction de glissement ("right" ou "left")
     */
    slideColumn: function(direction) {
      this.$store.dispatch("swipeDisplayedColumns", direction);
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"


.sub-theme-content
  display: table
  position: relative
  padding: 0 25px
  width: 100%

  @media print
    padding: 0

.sub-theme-row
  display: table-row

.slice-column-container
  display: table-cell 


.arrow-shape-left
  width: 0
  height: 0
  border-top: 25px solid transparent
  border-right: 18px solid $darkgray-3
  border-bottom: 25px solid transparent
  border-left: none
  position: absolute
  top: 2px
  left: 0
  cursor: pointer

  &:hover
    border-right: 18px solid $gray-3

.arrow-shape-right
  width: 0
  height: 0
  border-top: 25px solid transparent
  border-left: 18px solid $darkgray-3
  border-bottom: 25px solid transparent
  border-right: none
  position: absolute
  top: 2px
  right: 0
  cursor: pointer

  &:hover
    border-left: 18px solid $gray-3
  
</style>

